export default __webpack_public_path__ + "static/media/impishhorde.7e04e47f.png";